// ============================================
// Seed Templates: Business Planning
// Category: business-planning
// Templates: 6
// ============================================

import type { DocTemplate } from '../../types/docops';

export const SEED_TEMPLATES_BUSINESS: DocTemplate[] = [
  // ── 10.1 Staffing Plan ──
  {
    id: '10.1-staffing-plan',
    categoryId: 'business-planning',
    track: 'planning',
    title: 'Staffing Plan',
    description:
      'Team structure, hiring timeline, role definitions, and compensation ranges.',
    templateContent: '',
    requiredVariables: ['brandName', 'ceoName'],
    generationPrompt:
      'Already built as internal planning document.',
    attorneyReviewRequired: false,
    launchBlocker: false,
    estimatedPages: 0,
    sortOrder: 1,
    generationRound: 6,
    dependencies: [],
    anchorSections: [],
    inheritedProvisions: [],
  },

  // ── 10.2 Corporate Structure Playbook ──
  {
    id: '10.2-structure-playbook',
    categoryId: 'business-planning',
    track: 'planning',
    title: 'Corporate Structure Playbook',
    description:
      'MSO/PC/Trust structure rationale, entity relationships, and operational flow.',
    templateContent: '',
    requiredVariables: ['brandEntity', 'pcEntityName', 'trustName'],
    generationPrompt:
      'Already built as internal planning document.',
    attorneyReviewRequired: false,
    launchBlocker: false,
    estimatedPages: 0,
    sortOrder: 2,
    generationRound: 6,
    dependencies: [],
    anchorSections: [],
    inheritedProvisions: [],
  },

  // ── 10.3 Market Positioning Document ──
  {
    id: '10.3-market-positioning',
    categoryId: 'business-planning',
    track: 'planning',
    title: 'Market Positioning Document',
    description:
      'Target market analysis, competitive positioning, differentiation strategy.',
    templateContent: '',
    requiredVariables: ['brandName', 'marketVertical'],
    generationPrompt:
      'Already built as internal planning document.',
    attorneyReviewRequired: false,
    launchBlocker: false,
    estimatedPages: 0,
    sortOrder: 3,
    generationRound: 6,
    dependencies: [],
    anchorSections: [],
    inheritedProvisions: [],
  },

  // ── 10.4 Revenue Model ──
  {
    id: '10.4-revenue-model',
    categoryId: 'business-planning',
    track: 'planning',
    title: 'Revenue Model',
    description:
      'Revenue streams, unit economics, pricing strategy, growth projections.',
    templateContent: '',
    requiredVariables: ['brandName', 'consultationFee', 'supplementMarginPercent'],
    generationPrompt:
      'Already built as internal planning document.',
    attorneyReviewRequired: false,
    launchBlocker: false,
    estimatedPages: 0,
    sortOrder: 4,
    generationRound: 6,
    dependencies: [],
    anchorSections: [],
    inheritedProvisions: [],
  },

  // ── 10.5 Launch Checklist ──
  {
    id: '10.5-launch-checklist',
    categoryId: 'business-planning',
    track: 'planning',
    title: 'Launch Checklist',
    description:
      'Pre-launch requirements, go/no-go criteria, launch sequence, and rollback plan.',
    templateContent: '',
    requiredVariables: ['brandName'],
    generationPrompt:
      'Already built as internal planning document.',
    attorneyReviewRequired: false,
    launchBlocker: false,
    estimatedPages: 0,
    sortOrder: 5,
    generationRound: 6,
    dependencies: [],
    anchorSections: [],
    inheritedProvisions: [],
  },

  // ── 10.6 Acquisition Strategy ──
  {
    id: '10.6-acquisition-strategy',
    categoryId: 'business-planning',
    track: 'planning',
    title: 'Acquisition Strategy',
    description:
      'Acquisition positioning, target valuation, key metrics for acquisition readiness.',
    templateContent: '',
    requiredVariables: ['brandName', 'brandEntity'],
    generationPrompt:
      'Already built as internal planning document.',
    attorneyReviewRequired: false,
    launchBlocker: false,
    estimatedPages: 0,
    sortOrder: 6,
    generationRound: 6,
    dependencies: [],
    anchorSections: [],
    inheritedProvisions: [],
  },
];
